import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from 'src/services/auth.service';
import { tap, map, take } from 'rxjs/operators';
import {RefresherService} from "../services/refresher.service";

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  account: any = {};
  constructor(
    private auth: AuthService,
    private router: Router,
    private refresher: RefresherService
  ) {
    this.account = JSON.parse(localStorage.getItem('account'))
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.auth.user$.pipe(
      take(1),
      map(user => !!(user && user.roles.admin)),
      tap(isAdmin => {
        if (!isAdmin) {
          alert('Access denied. Must have permission to view content');
          //this.router.navigateByUrl(this.account.account_key + '/user/dashboard', {replaceUrl: true});
        }
      })
    );

  }

}
